import { SAMPLE_REPORTS_STATUSES } from '@/config/constants';

/** Laboratory used for the virtual excel preview report, which has no laboratory */
const PREVIEW_LABORATORY = 'Preview';

export default {
  /**
   * i18n key (`collapse.<key>`) of a report inside the reports collapse list.
   *
   * The key describes the document the user is going to download, not the report status:
   * a new revision brings the report status back to `toBeApproved` while the linked document
   * is still the last signed one. This mirrors GET /samples/{id}/reports/{reportId}/download,
   * which serves the draft only when status is `draft` and the latest final document otherwise.
   */
  reportLabelKey: (report) => {
    const laboratory = report.laboratory || PREVIEW_LABORATORY;
    if (report.status === SAMPLE_REPORTS_STATUSES.draft) {
      return `${laboratory}_${SAMPLE_REPORTS_STATUSES.draft}`;
    }
    if (report.isReportAvailable) {
      return `${laboratory}_${SAMPLE_REPORTS_STATUSES.approved}`;
    }
    return `${laboratory}_${report.status}`;
  },
};
